import React from "react";
import { Check, X as XIcon } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";
import { fmt, mediaUrl } from "../lib/api";
import { UNIT_LABEL } from "../lib/surfaces";

const bullets = (text) =>
  (text || "")
    .split("\n")
    .map((l) => l.replace(/^[-•]\s*/, "").trim())
    .filter(Boolean);

export const ItemDetailsDialog = ({ item, onClose }) => (
  <Dialog open={!!item} onOpenChange={() => onClose()}>
    <DialogContent
      className="max-h-[90vh] overflow-y-auto rounded-none sm:max-w-lg"
      data-testid="item-details-dialog"
    >
      {item && (
        <>
          <DialogHeader>
            <DialogTitle className="font-display uppercase tracking-tight">
              {item.name}
            </DialogTitle>
          </DialogHeader>

          {item.image_url && (
            <img
              src={mediaUrl(item.image_url)}
              alt={item.name}
              className="max-h-64 w-full border border-border object-cover"
            />
          )}

          <div className="flex items-baseline justify-between border-b border-border pb-2">
            <span className="label-xs text-muted-foreground">Prezzo unitario</span>
            <span className="font-mono-t text-lg font-bold text-[#4E7C59]">
              € {fmt(item.price)}/{UNIT_LABEL[item.unit] || item.unit} + IVA
            </span>
          </div>

          {item.description ? (
            <p className="text-sm leading-relaxed text-muted-foreground">{item.description}</p>
          ) : (
            <p className="text-sm text-muted-foreground">
              Descrizione non ancora disponibile per questa lavorazione.
            </p>
          )}

          {bullets(item.included).length > 0 && (
            <div>
              <div className="label-xs mb-2 text-[#4E7C59]">Cosa è incluso</div>
              <ul className="space-y-1.5" data-testid="item-included-list">
                {bullets(item.included).map((line, i) => (
                  <li key={i} className="flex gap-2 text-sm">
                    <Check className="mt-0.5 h-4 w-4 flex-none text-[#4E7C59]" />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {bullets(item.excluded).length > 0 && (
            <div>
              <div className="label-xs mb-2 text-destructive">Cosa non è incluso</div>
              <ul className="space-y-1.5" data-testid="item-excluded-list">
                {bullets(item.excluded).map((line, i) => (
                  <li key={i} className="flex gap-2 text-sm text-muted-foreground">
                    <XIcon className="mt-0.5 h-4 w-4 flex-none text-destructive" />
                    <span>{line}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </>
      )}
    </DialogContent>
  </Dialog>
);
